import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './global-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class GlobalDetailComponent extends AbstractCollectionDirective {}
